import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Access, AccessResponse, AccessVehicleResponse, IAccesssService } from './access.interface';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { LanguageUtils } from '../../utils/language.utils';

@Injectable({
  providedIn: 'root'
})
export class AccessService implements IAccesssService {
  constructor(
    private httpClient: HttpClient,
    private readonly authService: AuthService
  ) { }

  getAccessesByVehicle(plate: string, year: number = new Date().getFullYear(), limit = 100, offset = 0): Observable<AccessVehicleResponse> {
    year = Number.parseInt(year.toString());
    const from = year + '-01-01';
    const to = (year + 1) + '-01-01';
    return this.httpClient.get<AccessVehicleResponse>(environment.apiPublicUrl + '/detections/vehicle?applicant=' + this.authService.getCurrentUser().documentNumber + '&plate=' + plate + '&from=' + from + '&to=' + to + '&limit=' + limit + '&offset=' + offset + '&language=' + LanguageUtils.getLanguage());
    // return mock
    // return new Observable<AccessVehicleResponse>(subscriber => {
    //   subscriber.next({
    //     plate: '2108CSD',
    //     municipalities: [
    //       {
    //         location: 'Terrassa',
    //         detectionsPermitted: 3,
    //         detections: [
    //           {
    //             timestamp: {
    //               timestamp: '2024-07-24T09:46:01.000+02:00'
    //             },
    //             state: 'Not registered',
    //             number: 1
    //           },
    //           {
    //             timestamp: {
    //               timestamp: '2024-07-24T12:23:07.000+02:00'
    //             },
    //             state: 'Not registered',
    //             number: 1
    //           }
    //         ],
    //         detectionsNonRegistered: 2
    //       }
    //     ]
    //   });
    // });
  }
  getAccessesByVehicleAndApplicant(plate: string, applicantId: string, year: number = new Date().getFullYear(), limit = 100, offset = 0): Observable<AccessVehicleResponse> {
    year = Number.parseInt(year.toString());
    const from = year + '-01-01';
    const to = (year + 1) + '-01-01';
    return this.httpClient.get<AccessVehicleResponse>(environment.apiPublicUrl + '/detections/vehicle?applicant=' + applicantId + '&plate=' + plate + '&from=' + from + '&to=' + to + '&limit=' + limit + '&offset=' + offset + '&language=' + LanguageUtils.getLanguage());
    // return mock
    // return new Observable<AccessVehicleResponse>(subscriber => {
    //   subscriber.next({
    //     plate: '2108CSD',
    //     municipalities: [
    //       {
    //         location: 'Terrassa',
    //         detectionsPermitted: 3,
    //         detections: [
    //           {
    //             timestamp: {
    //               timestamp: '2024-07-24T09:46:01.000+02:00'
    //             },
    //             state: 'Not registered',
    //             number: 1
    //           },
    //           {
    //             timestamp: {
    //               timestamp: '2024-07-24T12:23:07.000+02:00'
    //             },
    //             state: 'Not registered',
    //             number: 1
    //           }
    //         ],
    //         detectionsNonRegistered: 2
    //       }
    //     ]
    //   });
    // });
  }
  getAccessesByMunicipality(municipality: string, year: number = new Date().getFullYear(), limit = 100, offset = 0): Observable<AccessResponse> {
    year = Number.parseInt(year.toString());
    const from = year + '-01-01';
    const to = (year + 1) + '-01-01';
    return this.httpClient.get<AccessResponse>(environment.apiPublicUrl + '/detections?applicant=' + this.authService.getCurrentUser().documentNumber + '&municipality=' + municipality + '&from=' + from + '&to=' + to + '&limit=' + limit + '&offset=' + offset + '&language=' + LanguageUtils.getLanguage());
  }
  getAccessesByVehicleMunicipality(plate: string, municipality: string, year: number = new Date().getFullYear(), limit = 100, offset = 0): Observable<AccessResponse> {
    year = Number.parseInt(year.toString());
    const from = year + '-01-01';
    const to = (year + 1) + '-01-01';
    return this.httpClient.get<AccessResponse>(environment.apiPublicUrl + '/detections?applicant=' + this.authService.getCurrentUser().documentNumber + '&plate=' + plate + '&municipality=' + municipality + '&from=' + from + '&to=' + to + '&limit=' + limit + '&offset=' + offset + '&language=' + LanguageUtils.getLanguage());
  }
  addAccess(newAccess: Access): Observable<number> {
    return this.httpClient.post<number>('/api/access', newAccess);
  }
  updateAccess(AccessToUpdate: Access): Observable<string> {
    return this.httpClient.put<string>('/api/access', AccessToUpdate);
  }
  deleteAccess(AccessId: number): Observable<string> {
    return this.httpClient.delete<string>('/api/access/' + AccessId);
  }
}
